import { Row, Col } from 'antd';
import { useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBookings } from '../redux/actions/bookingActions';


function Bookings() {
    const {bookings} = useSelector((state) => state.bookings);

    const [totalBookings, setTotalBookings] = useState([]);

    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getAllBookings());
    }, []);

    useEffect(() => {
        setTotalBookings(bookings);
    }, [bookings]);

    
    return (
        <Row gutter={24} justify='center'>

            <h4>All Bookings - {bookings.length}</h4>

            <Col lg={24} sm={24} xs={24}>

                <table className="table table-striped table-bordered table-responsive-sm">
                    <thead className='bs'>
                        <tr>
                            <th>Booking Id</th>
                            <th>Transaction Id</th>
                            <th>Total Hours</th>
                            <th>Amount</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {totalBookings.map((booking)=>{
                            return( 
                                <tr key={booking._id}>
                                    <td>{booking._id}</td>
                                    <td>{booking.transactionId}</td>
                                    <td>{booking.totalHours}</td>
                                    <td>{booking.totalAmount}</td>
                                    <td>{booking.bookedTimeSlots.from}</td>
                                    <td>{booking.bookedTimeSlots.to}</td>
                                    <td>{booking.status}</td>
                                </tr>
                            ); 
                        })}
                    </tbody>
                </table>

            </Col>
        </Row>
    );
}

export default Bookings;
